import styled from 'foundations-theming-specialty/utils';
import { IconButtonWrapper } from './CollapsiblePanelHeader';
export const PanelWrapper = styled.div.withConfig({
  displayName: "CollapsiblePanelStyles__PanelWrapper"
})(["background-color:", ";color:", ";display:flex;flex-direction:column;height:100%;flex:", ";width:", ";", " border-color:", ";transition:width 0.1s ease,flex 0.1s ease;&:hover ", ",&:focus-within ", "{width:", ";opacity:1;transform:translateX(0);margin-inline-end:", ";pointer-events:auto;}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['text-core-default'], ({
  $isCollapsed
}) => $isCollapsed ? '0 0 80px' : '0 0 350px', ({
  $isCollapsed
}) => $isCollapsed ? '80px' : '350px', ({
  $borderSide
}) => `
    border-inline-${$borderSide}-width: 1px;
    border-inline-${$borderSide}-style: solid;
  `, ({
  theme
}) => theme.color['border-core-disabled'], IconButtonWrapper, IconButtonWrapper, ({
  theme
}) => theme.space['800'], ({
  theme,
  $isCollapsed
}) => $isCollapsed ? '0' : theme.space['200']);
export const ContentWrapper = styled.div.withConfig({
  displayName: "CollapsiblePanelStyles__ContentWrapper"
})(["display:flex;flex-direction:column;gap:", ";flex:1;min-width:0;opacity:", ";transition:opacity 0.3s ease;overflow-x:hidden;overflow-y:auto;padding-inline:", ";padding-block-end:", ";"], ({
  theme
}) => theme.space['500'], ({
  $isCollapsed
}) => $isCollapsed ? '0' : '1', ({
  theme,
  $isCollapsed,
  $flushBody
}) => $flushBody ? '0' : $isCollapsed ? theme.space['600'] : theme.space['500'], ({
  theme,
  $flushBody
}) => $flushBody ? '0' : theme.space['400']);
export const RotatedIcon = styled.span.withConfig({
  displayName: "CollapsiblePanelStyles__RotatedIcon"
})(["display:contents;& > svg{transform:rotate(180deg);}"]);